module.exports = __webpack_public_path__ + "img/bozjansouthernfront.6ab9709b.jpg";